import { CanDeactivateFn } from '@angular/router';
import type { PdfEditorComponent } from '../components/document-editing/pdf-editor/pdf-editor.component';

export const pdfEditorUnsavedGuard: CanDeactivateFn<PdfEditorComponent> = (component) =>
  component.canLeaveEditor();
